import React, { Component } from 'react';
import { Radio, RadioGroup } from '@cimpress/react-components';

export default class RadioDemo extends Component {
  state = {
    selected: 'example1',
  };

  onChange = (e, value) => {
    this.setState({ selected: value });
  };

  render() {
    return (
      <div>
        <form>
          <RadioGroup onChange={this.onChange} defaultSelected={this.state.selected} name="radioTest">
            <Radio label="Example 1" value="example1" />
            <h5>interspersed non-radio component</h5>
            <Radio label={<i>Example 2</i>} value="example2" />
            <Radio label="Example 3" value="example3" disabled />
          </RadioGroup>
        </form>
      </div>
    );
  }
}
